export default "__VITE_ASSET__BIN1CYk___"